import axios from 'axios'

// const API_URL = process.env.API_URL || 'http://localhost:8765/api/'

export const AXIOS = axios.create({
  baseURL: '/',

  headers: {
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
  }
})
AXIOS.defaults.timeout = 30000
